
import styles from "../styles/bloque02.module.css";



function Bloque02({
  imagen,
  titulo1,
  titulo2,
  descripcion,
  tipo
}) {
  return (
    <section className={styles.section_bloque02}>
      {}
      {imagen && (
        <div className={styles.imagenContainerBloque01}>
          <img src={imagen} alt="Imagen sección" className={styles.imagenBloque01} />
        </div>
      )}

      <div className={styles.textoContainerBloque01}>
        <div className={styles.containertituloBloque01}>
          <div className={styles.lineaYtexto}>
            
            <span
              className={
                tipo === 'esport'
                  ? styles.lineaBloqueEsport
                  : styles.lineaBloqueSalut
              }
            />

            <div className={styles.textoTitulo}>
             
              {titulo1 && <span className={styles.tituloLinea}>{titulo1}</span>}
             
              {titulo2 && <span className={styles.tituloLinea}>{titulo2}</span>}
            </div>
          </div>
        </div>

        {descripcion && (
          <p className={styles.descripcionBloque01}>
            {descripcion}
          </p>
        )}
      </div>
    </section>
  );
}
export default Bloque02;

